export default "__VITE_ASSET__QCA8LKHl__"